import Ev from '../../../lib/event';

export default [
    'selectCategory',
    'selectFeed',
    'browseImages',
    'closeAssetModal',
    'chooseImage',
    'selectCategoryImage',
    'selectStreamImage',
    'channelTypeChange',
    'changeBeginDate',
    'changeChannelName',
    'changeTarget',
    'save',
    'shiftError',
    'startUpload'
].reduce(function (acc, type) {
    acc[type] = Ev(type);
    return acc;
}, {});